module.exports = __webpack_public_path__ + "static/media/bunu_front_of_mirror.6208f674.gif";